import { atom } from 'jotai';

export const firstAtom = atom(0);
export const selectedRoutePath = atom(0);
export const layersDataState = atom({});
export const openKmzBar = atom(false);
export const leasingPoints = atom(false);
export const selectedKmz = atom(null);
export const selectedRouteOnMap = atom(null);
export const partnerOrRoute = atom('partner');
export const selectedDisplayedKmz = atom([]);
export const regionsKmz = atom([]);
export const citiesKmz = atom([]);
export const openUploadKmz = atom(false);
export const openCompareRoutes = atom(false);
export const openDeleteKmz = atom(false);
export const noNetwork = atom(false);
export const kmzNetwork = atom('FTTS');
export const regionForkmzNetwork = atom('');
export const partnerForkmzNetwork = atom('');
export const cityForkmzNetwork = atom('');
export const kmzUploadResponse = atom(null);
export const allKmzs = atom([]);
export const geoServerResponseLinks = atom([]);
export const geoServerResponseSites = atom([]);
export const geoServerResponseLinksFtts = atom([]);
export const geoServerResponseSitesFtts = atom([]);
export const geoServerResponseLinksMpbn = atom([]);
export const geoServerResponseSitesMpbn = atom([]);
export const geoServerResponseLinksOtn = atom([]);
export const geoServerResponseSitesOtn = atom([]);
export const geoServerResponseLinksIpran = atom([]);
export const geoServerResponseSitesIpran = atom([]);
export const filteredKmzForDisplayed = atom([]);
export const lat = atom(30.3753);
export const Long = atom(69.3451);
export const routeSelection = atom(false);
export const partnerNetwork = atom(false);
export const myFiber = atom(true);
export const leasedFiber = atom(true);
export const rowFiber = atom(true);
export const networkVisulization = atom('FTTS');
export const showRanSitesAtom = atom(true);
export const showFiberSitesAtom = atom(true);
export const showFiberCablesAtom = atom(true);

// Route Analysis

export const allDeploymentRoutes = atom([]);
export const allLeasingRoutes = atom([]);
export const allFetchedRoutes = atom([]);
export const selectedNavRouteAtom = atom(null);
export const editRoute = atom(false);
export const comparisonRouteData = atom(null);
export const mapMarkersOnSelectedRoute = atom([]);
export const openRouteNamePopUp = atom(false);
export const openCostModal = atom(false);

// Ran DB
export const openUploadFormRanDb = atom(false);
export const openUploadFileRanDb = atom(false);
export const openAddInfoFormRanDb = atom(false);
export const openReviewForFile = atom(false);
export const ranDbFileUploadResponse = atom(null);
export const stepsUpload = atom(['New Sites', 'Updated Record', 'Missing Sites']);
export const currentUploadStep = atom(0);
export const allSitesRanDb = atom([]);
export const selectedRanDbRow = atom(null);
export const ranDbViewMode = atom('detailed'); // 'overview', 'detailed', 'archived'
export const ranDbArchivedType = atom('all'); // 'all', 'Dismantle', 'Relocation', 'Other'
export const openDeleteSiteModal = atom(false);
export const selectedSiteForDeletion = atom(null);
export const ranDbTotalCount = atom(0);
export const ranDbTotalPages = atom(0);
export const ranDbCurrentPage = atom(1);
export const ranDbPageSize = atom(50);

// FTTS Site List
export const openAddInfoFormFiberSitePlanning = atom(false);
export const allSitesFiberSitePlanning = atom([]);
export const selectedFiberSitePlanningRow = atom(null);
export const fiberSitePlanningViewMode = atom('detailed'); // 'overview', 'detailed'
export const openEditFiberSitePlanningModal = atom(false);

// Report Generation State
export const selectedReportFields = atom([]);
export const selectedReportFilters = atom({});
export const reportData = atom([]);

// Upload process atoms
export const selectedNewSites = atom({});
export const selectedUpdatedSites = atom({});
export const selectedDeletedSites = atom({});

// Main Screen
export const backGroundColorMainScreen = atom('#EEF1FA');
export const openSketcher = atom(false);
export const openLeftDrawer = atom(false);
// Network Monitoring States
export const loadingApiAtom = atom(true);
